export const ModalSize = {
  SMALL: '500px',
  LARGE: '800px',
  XL: '1140px',
  FULL: 'calc(100vw - 80px)',
};

export const MOBILE_PAPER_SX = {
  display: 'flex',
  justifyContent: 'center',
  width: '100vw',
  maxWidth: '100vw',
  height: '100%',
  maxHeight: '100%',
  margin: 0,
  borderRadius: 0,
  overflow: 'hidden',
  // On native (notched) devices the full-screen dialog covers the status bar / home indicator,
  // putting the header's close button under the notch. Inset by the safe areas (0 in a browser).
  paddingTop: 'env(safe-area-inset-top, 0px)',
  paddingBottom: 'env(safe-area-inset-bottom, 0px)',
};

export const getPaperProps = ({ size, fitContentWidth }) => ({
  sx: {
    display: 'flex',
    justifyContent: 'center',
    width: fitContentWidth ? 'fit-content' : size,
    maxWidth: fitContentWidth ? '90vw' : size,
    maxHeight: 'calc(100% - 80px)',
    margin: '40px',
    borderRadius: ({ shape }) => shape.radius.l,
    boxShadow: ({ palette }) => palette.shadow.l,
    overflow: 'hidden',
  },
});

export const slotProps = {
  backdrop: {
    sx: {
      backgroundColor: ({ palette }) => palette.background.backdrop,
    },
  },
  root: {
    sx: {
      '& .MuiDialog-container': {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
  },
};
